export default __webpack_public_path__ + "static/media/Snd_CH.44b09755.mp3";